<div class="bg-gray-50 flex" style="min-height: 100vh;">
  <!-- Loader -->
  @if (loaderService.isLoading$ | async) {
    <app-loader></app-loader>
  }

  <!-- Mobile overlay -->
  @if (isSidebarOpen && showLayout) {
    <div
      (click)="closeSidebar()"
      class="fixed inset-0 bg-opacity-50 z-30 lg:hidden"></div>
  }

  <!-- Sidebar -->
  @if (showLayout) {
    <div
      [class.translate-x-0]="isSidebarOpen"
      [class.-translate-x-full]="!isSidebarOpen"
      class="w-64 bg-white shadow-sm border-r border-gray-200 fixed h-full z-40 transition-transform duration-300 lg:translate-x-0">
      <app-sidebar (linkClick)="closeSidebar()"></app-sidebar>
    </div>
  }

  <!-- Main Content -->
  <div class="flex-1" [class.lg:ml-64]="showLayout">
    <!-- Mobile menu button -->
    @if (showLayout) {
      <button
        (click)="toggleSidebar()"
        class="lg:hidden fixed top-3 left-3 z-50 p-2 rounded-lg bg-white shadow-md border border-gray-200 hover:bg-gray-50">
        <svg class="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          @if (!isSidebarOpen) {
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
          }
          @if (isSidebarOpen) {
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          }
        </svg>
      </button>
    }

    <!-- Header -->
    @if (showLayout) {
      <app-header></app-header>
    }

    <!-- Page Content -->
    <main [class.p-3]="showLayout" [class.sm:p-6]="showLayout" [class.pt-16]="showLayout" [class.sm:pt-20]="showLayout">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
